<template>
  <RexDataTable
    :loading="loadingBrowser"
    :headers="headersApp"
    :items="itemsApp"
    :search="true"
    :title="titleApp"
    :highlight="color"
    width="100%"
    height="48.375em"
    :total="itemsAppTotal"
    :pageNo="currentPage"
    @onPageChange="onAppPage"
    @onSearchChange="onAppSearch"
    @updateSearch="onAppSort"
    @redirectInput="redirectAppInput"
    @onClear="clearSearchApp"
    :defualtPageProps="getDefaultPageProps()"
  />
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import RexDataTable from '@/rex-components/rex-DataTable.vue';
import debounce from 'lodash/debounce';
import { MetricType, Capability, ScopeType } from '@/utils/enums/metricType';
import { BrowserOverviewHeader } from '@/utils/enums/headerType';
import { SortOrder } from '@/utils/enums/sortOrder';

export default {
  name: 'BrowserOverview',
  components: {
    RexDataTable,
  },
  data: function () {
    return {
      loadingBrowser: true,
      metricApp: MetricType.ALERTS,
      orderApp: SortOrder.DES,
      keywordApp: '',
      pageSizeApp: 15,
      currentPage: 1,
      pageSize: 10,
      itemsTotal: 0,
      itemsAppTotal: 0,
      titleApp: this.$t('browserMonitoring'),
      color: 'secondary',
      itemsApp: [],
      search: true,
      items: [],
      headersApp: [
        {
          key: BrowserOverviewHeader.SERVICE_NAME,
          name: this.$t('name'),
          width: '35%',
          sortable: false,
        },
        {
          key: BrowserOverviewHeader.TOTAL_ALERTS,
          name: this.$t('alerts'),
          width: '15%',
          sortable: true,
          defaultOrder: SortOrder.DES,
          defaultSortBy: true,
        },
        {
          key: BrowserOverviewHeader.APDEX,
          width: '15%',
          name: this.$t('apdexTitle'),
          sortable: true,
          dataType: 'float',
        },
        {
          key: BrowserOverviewHeader.RESP,
          width: '25%',
          name: this.$t('loadTimeMS'),
          sortable: true,
          dataType: 'float',
        },
        {
          key: BrowserOverviewHeader.CPM,
          name: this.$t('callsPerMin'),
          width: '20%',
          dataType: 'float',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('homeState', ['browserData', 'browserDataTotal']),
  },
  watch: {
    getDurationTime: function (newValue, oldValue) {
      this.currentPage = 1;
      this.loadService();
    },
  },
  mounted: function () {
    this.loadService();
  },
  methods: {
    ...mapActions('browserState/browserCommonState', ['selectBrowserService']),
    ...mapActions('homeState', ['GET_BROWSER_META']),
    async loadService() {
      const params = {
        condition: {
          keyword: this.keywordApp,
          filterCondition: {
            scope: ScopeType.SERVICE,
            metricType: this.metricApp,
            order: this.orderApp,
          },
          pagination: {
            pageNum: this.currentPage,
            pageSize: this.pageSizeApp,
            needTotal: true,
          },
          duration: this.getDurationTime,
          serviceReq: {
            capability: Capability.BROWSER,
          },
        },
      };
      try {
        await this.GET_BROWSER_META(params);
      } catch (error) {
        console.log('error', error);
      } finally {
        this.loadingBrowser = false;
      }
      this.itemsApp = this.browserData;
      this.itemsAppTotal = this.browserDataTotal;
    },
    handleSearch: debounce(function () {
      this.loadService();
    }, 300),
    onAppSearch(data) {
      this.currentPage = 1;
      this.keywordApp = data;
      this.handleSearch();
    },
    onAppPage(state) {
      this.currentPage = state.pageNo;
      this.pageSizeApp = state.pageSize;
      this.loadService();
    },
    onAppSort(data) {
      this.orderApp = data.order;
      switch (data.header) {
        case BrowserOverviewHeader.TOTAL_ALERTS:
          this.metricApp = MetricType.ALERTS;
          break;
        case BrowserOverviewHeader.RESP:
          this.metricApp = MetricType.RESP;
          break;
        case BrowserOverviewHeader.APDEX:
          this.metricApp = MetricType.APDEX;
          break;
        case BrowserOverviewHeader.CPM:
          this.metricApp = MetricType.CALLS;
          break;
      }
      this.loadService();
    },
    redirectAppInput(option) {
      const query = {
        id: option.serviceID,
      };

      this.$router.push({
        name: 'browser',
        query,
      });
    },
    clearSearchApp() {
      this.keywordApp = '';
      this.currentPage = 1;
      this.loadService();
    },
    getDefaultPageProps() {
      return ['15', '30', '50'];
    },
  },
};
</script>
<style lang="scss" scoped></style>
